import React, { useState } from "react";
import {
  PolyCGPA,
  University,
  UniversityCGPA,
  cgpas,
  collegeCGPA,
} from "../component.js/data";
import { LSSB } from "../utils/LSSB_live";
import { Link, useLocation } from "react-router-dom";
import { ClipLoader } from "react-spinners";
import { enqueueSnackbar } from "notistack";
import Modal from "../component.js/Modal";
import { ArrowLeft, CloseCircle, Verify } from "iconsax-react";
import PreviewItem from "../component.js/PreviewItem";
import { nigerianBanks } from "../utils/helperFunction";

export const classLevels = [
  { value: 1, text: "Year 1" },
  { value: 2, text: "Year 2" },
  { value: 3, text: "Year 3" },
  { value: 4, text: "Year 4" },
  { value: 5, text: "Year 5" },
  { value: 6, text: "Year 6" },
  { value: 7, text: "Year 7" },
];

export const Duration = [
  { value: 1, text: "1" },
  { value: 2, text: "2" },
  { value: 3, text: "3" },
  { value: 4, text: "4" },
  { value: 5, text: "5" },
  { value: 6, text: "6" },
  { value: 7, text: "7" },
  { value: 8, text: "8" },
  { value: 9, text: "9" },
];

const Register = () => {
  const location = useLocation();
  let userData = sessionStorage.getItem("lssbAdminData");
  userData = JSON.parse(userData);
  const { eduLevel, grantInfo } = location.state;
  const [isLoading, setIsLoading] = useState(false);
  const [isApplSuccess, setIsApplySuccess] = useState(false);
  const [preview, setPreview] = useState(false);

  function openPreview(e) {
    e.preventDefault();

    setPreview(true);
  }

  function closePreview() {
    setPreview(false);
  }

  const [indigeneshipVerification, setIndigeneshipVerification] =
    useState("Manual");
  const [studentshipVerification, setStudentshipVerification] =
    useState("Manual");
  const [formValue, setFormValue] = useState({
    university: "",
    courseOfStudy: "",
    yearOfAdmission: "",
    cgpa: "",
    yearOfGrauation: "",
    matricNo: "",
    level: "",
    refreeName: "",
    refreeAddress: "",
    refreePhone: "",
    division: "",
    institutionType: "",
    courseDuration: "",
    cgpaValue: "",

    Account_Number: "",
    Bank_Name: "",
    Account_Name: "",
  });
  const currentYear = new Date().getFullYear();
  const numberOfFutureYears = 10; // Adjust this value based on how many future years you want to include
  const leastCgpa = parseFloat(0.1);
  const maxCgpa = parseFloat(5.0);

  const generateYearOptions = () => {
    const years = [];
    for (let i = 0; i <= numberOfFutureYears; i++) {
      years.push(currentYear + i);
    }
    return years;
  };
  const generateAddmissionYearOptions = () => {
    const years = [];
    for (let i = 0; i <= numberOfFutureYears; i++) {
      years.push(currentYear - i);
    }
    return years;
  };
  const generateCgpa = () => {
    const cgpa = [];
    for (let i = parseFloat(0.1); i <= maxCgpa; i++) {
      cgpa.push(leastCgpa + i);
    }
    return cgpa;
  };

  const yearRemaining = (e) => {
    const yearOfAdmission = parseInt(formValue.yearOfAdmission);
    const courseDuration = e.target.value;
    // const level = ;
    const remainingYear = parseInt(courseDuration) + yearOfAdmission;
    ////console.log("remaining year", remainingYear)

    setFormValue({
      ...formValue,
      yearOfGrauation: isNaN(remainingYear) ? 0 : remainingYear,
      courseDuration,
    });
  };

  // ////console.log("remaining year", formValue?.yearOfGrauation)

  const applyGrant = async (e) => {
    // e.preventDefault();
    setIsLoading(true);
    try {
      let res = await LSSB.make_API_call({
        _endpoint: "create_application",
        $k: userData?.token,

        _fields: {
          applicant_fullname: userData?.user?._fields?.fullname,
          grant_access_mode: grantInfo?._fields.grant_access_mode, // free, paid, pin

          grant_id: grantInfo?._id, // ID of the grant being applied for
          // @@ will check
          // 1. if applicaton is open or closed before proceeding
          // 2. if grant is paid access mode then check pay staus.

          applicant_id: userData?.user?._id,
          // very important, so we can
          // 1. join their profile details when fetching applications later
          // 2. check payment status on invoice if it's a paid access grant

          grant_type: grantInfo?._fields.grant_type, // bursary, scholarship, special_scholarship, foo_scholarship etc
          // @@ important... invoices, etc of paid access grants will be generated with this key
          // -- like in the huge sample object above

          grant_type_code: grantInfo?._fields.grant_type_code,
          grant_batch:grantInfo?._fields.batch,

          // @@ Edu level will be required for sorting later
          edu_level: eduLevel,
          // values: 'undergraduate', 'maritime_academy', 'law_school', 'masters', 'phd', 'others' for (compassionate etc)

          // @@ applicant's division will be required for sorting later
          applicant_division: formValue?.division, // the 5 lagos division plus "others" for non indigenes

          // @@ applicantion year will  be required for sorting later
          application_year: "2024-2025", // usually the current year - the year after

          // @@ applicant
          application_year_code: "2425", // -- required for backend blah blah...

          school: formValue.university,

          grant_name: grantInfo?._fields.grant_name,

          // @@ -============= other fields  that can be updated by Applicant later
          academic_result: formValue?.cgpa,
          academic_result_value: formValue?.cgpaValue,
          // @@ label should be : Academic result / CGPA for your form field
          // -- reason is, different institutions have diff names for academic results
          applicant_email: userData?.user?._fields?.email,

          application_status: "pending", // pending - default, Approved, rejected
          institution_type: formValue.institutionType,
          matric_no: formValue.matricNo,
          current_level: formValue.level,
          course: formValue.courseOfStudy,
          study_duration: formValue?.courseDuration,
          year_of_admission: formValue.yearOfAdmission,
          year_of_completion: formValue.yearOfGrauation,
          refree: formValue.refreeName,
          refree_phone: formValue.refreePhone,
          refree_address: formValue.refreeAddress,
          approval_status: "Unapproved",
          Pass_approval: "Pending",
          Es_approval: "Pending",
          Audit_approval: "Pending",
          Finance_approval: "Pending",
          Cbt_verification: "Pending",
          Bank_name: formValue?.Bank_Name,
          Bank_account: formValue?.Account_Number,
          Account_name: formValue?.Account_Name,
        },

        _academic_criteria: {
          cbt_score: null, // set default
          cgpa: formValue?.cgpa, // first_class, second_class_upper etc.... FrontEnd defines.
          cgpa_value: formValue.cgpaValue,
          studentship_status: "Unverified", // ** required
          Studentship_verification: studentshipVerification, // returns
          Indegeneship_verification: indigeneshipVerification,
          indigeneship_status: "Unverified", // ** required
          amount_due: 0.0,
        },
      });
      if (res?.success == true) {
        enqueueSnackbar(res?.data?.msg, { variant: "success" });
        setIsApplySuccess(true);
        // navigate("/");
        setIsLoading(false);
        closePreview();
      } else {
        enqueueSnackbar(res?.error?.msg, { variant: "error" });
        setIsLoading(false);
      }
    } catch (e) {
      console.error("Error applying grant", e);
      setIsLoading(false);
    }
  };

  const handleInputChange = (e) => {
    setFormValue({ ...formValue, [e.target.name]: e.target.value });
  };
  const InstitutionType = [
    { id: 1, value: "University" },
    { id: 2, value: "Polytechnic or Monotechnic" },
    { id: 3, value: "College of Education" },
  ];

  const eduType = ["Masters"];

  const removeInputByEduType = () => {
    const isEduType = eduLevel.includes(eduType);

    return isEduType;
  };

  return (
    <div className="p-[16px] md:px-[24px] xl:p-[32px]">
      <div className="mb-[24px] md:mb-[28px] xl:mb-[32px]">
        <Link to="/grants">
          <ArrowLeft size={20} color="black" />
        </Link>
        <h3 className="text-[18px] md:text-[24px] font-meddium text-[#25324B]">
          Register
        </h3>
        <p className="text-[14px] md:text-[16px] font-meddium text-[#7C8493]">
          {" "}
          Please register to complete your application
        </p>
      </div>
{/* {eduLevel} */}
      <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] xl:p-[20px] rounded-lg">
        <form onSubmit={openPreview} className=" w-full mt-[20px]">
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Select Institution Type
            </label>
            <div className=" ">
              <select
                type="text"
                placeholder=""
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="institutionType"
                value={formValue.institutionType}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              >
                <option value="">Select Institution Type</option>
                {InstitutionType &&
                  InstitutionType.map((inst, index) => (
                    <option key={index} value={inst.value}>
                      {inst.value}
                    </option>
                  ))}
              </select>
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Select Institution
            </label>
            <div className=" ">
              <select
                type="text"
                placeholder="Enter Marital Status"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="university"
                value={formValue.university}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              >
                <option value="">Select Institution</option>
                {University &&
                  University.map((uni, index) => (
                    <option value={uni.value}>{uni.text}</option>
                  ))}
              </select>
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Year of Admission
            </label>
            <div className=" ">
              <select
                id="year-selector"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                value={formValue.yearOfAdmission}
                onChange={handleInputChange}
                name="yearOfAdmission"
                required
              >
                {/* {generateAddmissionYearOptions().map((year) => (
                  <option key={year} value={year}>
                    {year}
                  </option>
                ))} */}
                <option value="2025">2025/2026</option>
                <option value="2024">2024/2025</option>
                <option value="2023">2023/2024</option>
              </select>
            </div>
          </div>

          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Enter Course of Study
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder=" Enter course of study"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="courseOfStudy"
                value={formValue.courseOfStudy}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          {!removeInputByEduType() && (
            <div className="mb-[24px]">
              <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                Enter Course Duration
              </label>
              <div className=" ">
                <input
                  type="text"
                  placeholder=" Enter course of duration"
                  className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                  required
                  autoComplete="on"
                  name="courseDuration"
                  value={formValue.courseDuration}
                  onChange={(e) => yearRemaining(e)}
                  autoCapitalize="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
              </div>
            </div>
          )}

          <div className="mb-[16px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Enter Matric Number
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder=" Enter matric no"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="matricNo"
                value={formValue.matricNo}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          {/* <button
            type="button"
            className=" py-[14px] px-[14px]  text-center text-white bg-[#AF8544]  flex items-center justify-center  md:mb-[24px]"
          >
            Verify Studentship
          </button> */}
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Current Level
            </label>
            <div className=" ">
              <select
                type="text"
                placeholder=""
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="level"
                value={formValue.level}
                onChange={(e) =>
                  setFormValue({ ...formValue, level: e.target.value })
                }
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              >
                <option value="">Select current class/level</option>
                {classLevels &&
                  classLevels
                    .slice(
                      grantInfo?._fields.grant_type ===
                        "lagos_state_scholarship" &&
                        (eduLevel !== "Masters" && eduLevel !== "P.H.D")
                        ? 1
                        : 0,
                      6
                    )
                    .map((lvl, index) => (
                      <option key={index} value={lvl.value}>{lvl.text}</option>
                    ))}
              </select>
            </div>
          </div>
          {!removeInputByEduType() && (
            <>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                  Expected Year of Graduation
                </label>
                <div className=" ">
                  <input
                    id="year-selector"
                    className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    value={formValue.yearOfGrauation}
                    //onChange={handleInputChange}
                    name="yearOfGrauation"
                    required
                  />
                </div>
              </div>
            </>
          )}

          {formValue.level > 1 && (
            <>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                  Current CGPA Class{" "}
                  <span className="text-[10px] md:text-[12px]">
                    (Select your institution type to see available class)
                  </span>
                </label>
                <div className=" ">
                  <select
                    id="year-selector"
                    className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    value={formValue.cgpa}
                    onChange={handleInputChange}
                    name="cgpa"
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                  >
                    <option value="">Select grade</option>
                    {(UniversityCGPA || PolyCGPA || collegeCGPA) &&
                      (formValue.institutionType === "University"
                        ? UniversityCGPA.map((inst, index) => (
                            <option key={index} value={inst.value}>
                              {inst.value}
                            </option>
                          ))
                        : formValue.institutionType ===
                          "Polythecnic or Monothecnic"
                        ? PolyCGPA.map((inst, index) => (
                            <option key={index} value={inst.value}>
                              {inst.value}
                            </option>
                          ))
                        : formValue.institutionType === "College of Education"
                        ? collegeCGPA.map((inst, index) => (
                            <option key={index} value={inst.value}>
                              {inst.value}
                            </option>
                          ))
                        : "")}
                    <option value="others">Others</option>
                  </select>
                </div>
              </div>
              <div className="mb-[24px]">
                <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
                  Current CGPA Value{" "}
                  <span className="text-[12px]">e.g(4.52)</span>
                </label>
                <div className=" ">
                  <input
                    id="year-selector"
                    className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                    value={formValue.cgpaValue}
                    onChange={handleInputChange}
                    name="cgpaValue"
                    required
                  />
                </div>
              </div>
            </>
          )}
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Division
            </label>
            <div className=" ">
              <select
                id="year-selector"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                value={formValue.division}
                onChange={handleInputChange}
                name="division"
                required
              >
                <option value="">Select Division</option>
                <option value="Badagry">Badagry</option>
                <option value="Epe">Epe</option>
                <option value="Ikeja">Ikeja</option>
                <option value="Ikorodu">Ikorodu</option>
                <option value="Lagos">Lagos</option>
                <option value="Non Indegene">Non Indegene</option>
              </select>
            </div>
          </div>

          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
              Bank Account Number
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder="0000 XXXX XX"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="account_number"
                value={formValue?.Account_Number}
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    Account_Number: e.target.value,
                  });
                }}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
              Bank Name
            </label>
            <div className=" ">
              <select
                type="text"
                placeholder="0000 XXXX XX"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                name="bank_name"
                value={formValue?.Bank_Name}
                onChange={(e) => {
                  setFormValue({ ...formValue, Bank_Name: e.target.value });
                }}
              >
                <option value="">-- Select Bank --</option>
                {nigerianBanks?.map((item) => (
                  <option value={item}>{item}</option>
                ))}
              </select>
            </div>
          </div>

          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal  text-[#515B6F] mb-[8px]">
              Account Name
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder="John Doe"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                required
                autoComplete="on"
                name="account_name"
                value={formValue?.Account_Name}
                onChange={(e) => {
                  setFormValue({
                    ...formValue,
                    Account_Name: e.target.value,
                  });
                }}
              />
            </div>
          </div>

          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Referee Name
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder=" Enter referee name"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                autoComplete="on"
                name="refreeName"
                value={formValue.refreeName}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Referee Phone No
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder=" Enter referee phone"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                autoComplete="on"
                name="refreePhone"
                value={formValue.refreePhone}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>
          <div className="mb-[24px]">
            <label className="text-[14px] md:text-[14px] xl:text-[16px] font-normal leading-[24px] text-[#515B6F] mb-[8px]">
              Referee Address
            </label>
            <div className=" ">
              <input
                type="text"
                placeholder=" Enter referee address"
                className="w-full h-[40px] px-[10px] py-[8px]  text-[#344054] leading-[20px] bg-[#F7F9FC] placeholder:text-[#98A2B3] placeholder:text-[12px]  border-[#D6DDEB] border-[1px]  focus:outline-none focus:ring-[#AF8544] focus:border-[#AF8544] "
                autoComplete="on"
                name="refreeAddress"
                value={formValue.refreeAddress}
                onChange={handleInputChange}
                autoCapitalize="off"
                autoCorrect="off"
                spellCheck="false"
              />
            </div>
          </div>

          <button
            type="submit"
            className="w-full py-[14px] text-center text-white bg-[#AF8544]  flex items-center justify-center mb-[20px] md:mb-[32px]"
          >
            <p className="text-sm font-medium leading-[20px]">
              Preview Registration
            </p>
          </button>
        </form>
      </div>

      <Modal
        isOpen={preview}
        onClose={() => {
          closePreview();
        }}
      >
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <button
            onClick={closePreview}
            className="absolute top-2 right-2 h-5 w-5 hover:bg-gray-200 flex justify-center items-center rounded-md"
          >
            <CloseCircle size={14} />
          </button>

          <h2 className="text-[16px] md:text-[20px] text-center font-medium leading-[35px] text-black mb-[16px] md:mb-[20px] ">
            Preview
          </h2>
          <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg grid grid-cols-2 items-start gap-x-5 gap-y-5">
            <PreviewItem
              title={"Award Type"}
              item={grantInfo?._fields.grant_name}
            />
            <PreviewItem title={"Education Level"} item={eduLevel} />
            <PreviewItem
              title={"Institution Type"}
              item={formValue?.institutionType}
            />
            <PreviewItem
              title={"Institution Name"}
              item={
                University &&
                University.map(
                  (uni, index) =>
                    formValue?.university === uni.value && (
                      <span key={index}>{uni.text}</span>
                    )
                )
              }
            />
            <PreviewItem
              title={"Year of Admission"}
              item={formValue?.yearOfAdmission}
            />
            <PreviewItem
              title={"Course Of Study"}
              item={formValue?.courseOfStudy}
            />
            <PreviewItem
              title={"Course Duration"}
              item={formValue?.courseDuration}
            />
            <PreviewItem title={"Matric Number"} item={formValue?.matricNo} />
            <PreviewItem
              title={"Current Class/Level"}
              item={formValue?.level}
            />
            <PreviewItem
              title={"Year of Graduation"}
              item={formValue?.yearOfGrauation}
            />
            <PreviewItem title={"Current CGPA Class"} item={formValue?.cgpa} />
            <PreviewItem
              title={"Current CGPA Value"}
              item={formValue?.cgpaValue}
            />
            <PreviewItem title={"Lagos"} item={formValue?.division} />
            <PreviewItem
              title={"Account Number"}
              item={formValue?.Account_Number}
            />
            <PreviewItem
              title={"Account Name"}
              item={formValue?.Account_Name}
            />
            <PreviewItem title={"Bank Name"} item={formValue?.Bank_Name} />
            <PreviewItem title={"Referee Name"} item={formValue?.refreeName} />
            <PreviewItem
              title={"Referee Address"}
              item={formValue?.refreeAddress}
            />
            <PreviewItem
              title={"Referee Phone"}
              item={formValue?.refreePhone}
            />
          </div>

          <div className="flex items-center  gap-[20px]">
            {" "}
            <button
              onClick={() => {
                closePreview();
              }}
              className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center "
            >
              <p className="text-white text-md md:text-lg  ">cancel</p>
            </button>
            <button
              onClick={() => {
                applyGrant();
              }}
              className="w-full mb-4 mt-8  py-[8px] md:py-[10px] bg-[#AF8544] text-center   flex items-center justify-center gap-2"
            >
              <p className="text-white text-md md:text-lg  ">Submit</p>
              {isLoading && <ClipLoader color={"white"} size={20} />}
            </button>
          </div>
        </div>
      </Modal>

      <Modal
        isOpen={isApplSuccess}
        onClose={() => {
          setIsApplySuccess(false);
        }}
      >
        <div className="inline-block relative border border-[#D6DDEB] p-[18px] md:p-[24px] xl:p-[32px] overflow-hidden text-left align-bottom transition-all transform bg-[white]   shadow-xl sm:my-8 sm:align-middle w-full min-w-[360px] md:min-w-[450px] md:max-w-[550px] ">
          <div className="border border-[#D6DDEB] p-[8px] md:p-[12px] rounded-lg">
            <Verify color={"#AF8544"} size={48} className="mt-6 mx-auto mb-6" />
            <h2 className="text-[20px] md:text-[24px] xl:text-[28px] text-center font-normal leading-[35px] text-black mb-[16px] md:mb-[20px] ">
              You have successfully applied for {grantInfo._fields.grant_name}
            </h2>
            <p className="text-sm md:text-[14px] text-center  font-normal text-[#515B6F]   ">
              You are required to check your application status on your
              applictaion page
            </p>

            <Link to="/myapplication">
              <button className="w-full  py-[8px] md:py-[10px] bg-[#AF8544] text-center mt-6 md:mt-7">
                <p className="text-white text-md md:text-lg  ">
                  Check Application Status
                </p>
              </button>
            </Link>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default Register;
